import { Component, inject, signal } from '@angular/core';
import { Router } from '@angular/router';
import { RefreshTokenService } from '../auth/refresh-token.service';
import { GrunddatenService } from '../grundlagen/grunddaten.service';
import { StartTermine } from './startTermine';
import { CustomKendoGridComponent } from '../shared/ui/ui-custom-kendo-grid.components';
import { environment } from '../../environment';
import { HttpClient } from '@angular/common/http';
import { RowClassArgs } from '@progress/kendo-angular-grid';
import { Allgemein } from '../grundlagen/allgemein';

@Component({
  selector: 'app-home',
  imports: [CustomKendoGridComponent],
  templateUrl: './home.component.html',
})
export class HomeComponent {
  constructor(
    private grunddaten: GrunddatenService,
    private router: Router,
    private rToken: RefreshTokenService,
  ) {}

  private readonly httpClient = inject(HttpClient);
  private readonly allgmein = inject(Allgemein);

  ngOnInit() {
    if (!this.grunddaten.istLogin) {
      if (this.rToken.refreshingTokens() == '') {
        this.router.navigate(['/login']);
      }
    }
    this.suchen();
  }

  termine = signal<StartTermine[]>([]);

  public suchen(): void {
    this.termine.set([]);
    this.httpClient.get<StartTermine[]>(environment.baseUrl() + 'start/termine/').subscribe({
      next: (erg: StartTermine[]) => {
        this.termine.set(erg);
      },
    });
  }

  termineAnzeigen(e: any): void {
    this.router.navigate([e.dataItem.url, e.dataItem.id]);
  }

  public rowCallback = (context: RowClassArgs): { [key: string]: boolean } => {
    const item = context.dataItem;
    const heute = new Date();
    heute.setHours(0, 0, 0, 0);

    const verfallsdatum = new Date(item.erinnerung);
    verfallsdatum.setHours(0, 0, 0, 0);

    const istAbgelaufen = verfallsdatum < heute;

    if (istAbgelaufen) {
      return { gridrot: true };
    }

    const istTagesAktuell = verfallsdatum.getTime() === heute.getTime();

    if (istTagesAktuell) {
      return { gridgelb: true };
    }

    return { gridgruen: true };
  };
}
